import PropTypes from "prop-types";
import React from "react";

import { Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

/**
 * NextDayIndicator is a badge to indicate that the flight lands after midnight.
 */

export const NextDayIndicator = (props) => {
  const { className } = props;

  return <Text {...getProps()}>{i18n("NextDayIndicator__TEXT")}</Text>;

  function getProps() {
    return {
      "aria-label": i18n("NextDayIndicator__TEXT_ARIA"),
      className,
      color: "next-day-indicator",
      prefixIcon: "NextDay",
    };
  }
};

NextDayIndicator.propTypes = {
  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,
};
